import UserSettingsContainer from "./UserSettingsContainer";

export default UserSettingsContainer;
